export default "__VITE_ASSET__Aj7vsmIi__"